import React from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { SkelCardGrid } from '../components/Skeletons';

const WorkspacePicker = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState(false);
  const workspaces = JSON.parse(localStorage.getItem('availableWorkspaces') || '[]');
  const preToken = localStorage.getItem('preToken');

  const handleSelect = async (workspaceId) => {
    setLoading(true);
    try {
      const API_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000';
      const res = await axios.post(`${API_URL}/api/users/select-workspace`, { 
        preToken, 
        workspaceId 
      });
      localStorage.setItem('token', res.data.token);
      localStorage.setItem('workspaceName', res.data.workspaceName);
      localStorage.setItem('user', JSON.stringify(res.data.user));
      localStorage.setItem('userRole', res.data.role);
      localStorage.removeItem('preToken');
      localStorage.removeItem('availableWorkspaces');
      navigate(`/workspace/${res.data.workspaceUuid}/dashboard`);
    } catch (err) {
      console.error('Selection failed');
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="auth-container">
        <div className="auth-card" style={{ maxWidth: '440px', padding: '48px 32px' }}>
          <div style={{ marginBottom: '32px' }}>
            <h1 style={{ fontSize: '24px', fontWeight: '700', letterSpacing: '-0.03em', marginBottom: '8px' }}>Switch Workspace</h1>
            <p style={{ color: '#9C978C' }}>Select an organization to continue</p>
          </div>
          <SkelCardGrid count={4} minWidth={260} avatar />
        </div>
      </div>
    );
  }

  return (
    <div className="auth-container">
      <div className="auth-card" style={{ maxWidth: '440px', padding: '48px 32px' }}>
        <div style={{ marginBottom: '32px' }}>
          <h1 style={{ fontSize: '24px', fontWeight: '700', letterSpacing: '-0.03em', marginBottom: '8px' }}>Switch Workspace</h1>
          <p style={{ color: '#9C978C' }}>Select an organization to continue</p>
        </div>
        
        <div className="workspace-picker-list" style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          {workspaces.map(ws => (
            <button 
              key={ws.id} 
              onClick={() => handleSelect(ws.id)} 
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '16px',
                padding: '20px',
                background: '#FFFFFF',
                border: '1px solid #E7E1D6',
                borderRadius: '14px',
                cursor: 'pointer',
                transition: 'all 0.15s ease',
                textAlign: 'left'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = '#111111';
                e.currentTarget.style.boxShadow = '4px 4px 0 rgba(17,17,17,.2)';
                e.currentTarget.style.transform = 'translateY(-2px)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = '#E7E1D6';
                e.currentTarget.style.boxShadow = 'none';
                e.currentTarget.style.transform = 'translateY(0)';
              }}
            >
              <div style={{
                width: '44px',
                height: '44px',
                background: '#111111',
                color: '#F9F4EE',
                borderRadius: '999px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '18px',
                fontWeight: '700'
              }}>
                {ws.name.slice(0, 1)}
              </div>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: '15px', fontWeight: '700', color: '#111111' }}>{ws.name}</div>
                <div style={{ fontSize: '12px', color: '#9C978C', marginTop: '4px' }}>{ws.role} Access</div>
              </div>
              <div style={{ fontSize: '18px', color: '#9C978C' }}>→</div>
            </button>
          ))}
        </div>
        
        <button 
          onClick={() => navigate('/login')}
          style={{
            marginTop: '32px',
            background: 'none',
            border: 'none',
            color: '#6B6862',
            fontSize: '14px',
            fontWeight: '600',
            cursor: 'pointer',
            transition: 'color 0.2s'
          }}
          onMouseEnter={(e) => e.currentTarget.style.color = '#111111'}
          onMouseLeave={(e) => e.currentTarget.style.color = '#6B6862'}
        >
          ← Use different account
        </button>
      </div>
    </div>
  );
};

export default WorkspacePicker;
